export function Hero() {
  const handleScheduleClick = () => {
    const vapiButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (vapiButton) {
      vapiButton.click();
    }
  };

  const handleViewServicesClick = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/43349923ffd8b9896055150642137396.jpg"
          alt="Professional Las Vegas remodeling services - backyard transformation"
          className="w-full h-full object-cover object-center"
          title="RW Construction Las Vegas - Quality Remodeling"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          ONE CALL,<br />MULTIPLE SOLUTIONS
        </h1>
        
        <p className="text-lg md:text-xl text-white/95 mb-10 font-light max-w-3xl mx-auto">
          Residential &amp; Commercial Remodeling Excellence in Las Vegas
        </p>
        
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <button 
            onClick={handleScheduleClick}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-full font-semibold text-base hover:bg-[#E55A2B] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Schedule Appointment
          </button>
          <button 
            onClick={handleViewServicesClick}
            className="bg-white/95 text-[#2C2C2C] px-8 py-4 rounded-full font-semibold text-base hover:bg-white transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            View Our Services
          </button>
        </div>

        <div className="absolute bottom-12 left-0 right-0 flex justify-center max-w-6xl mx-auto px-6">
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <div className="bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
              <span className="text-white text-sm font-medium">Licensed & Insured</span>
            </div>
            <div className="bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
              <span className="text-white text-sm font-medium">20+ Years Experience</span>
            </div>
            <div className="bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
              <span className="text-white text-sm font-medium">¡Hablamos Español!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}